import * as React from 'react';
import {Basic} from './Basic.story';
import {Onchange} from './Onchange.story';
import {Disabled} from './Disabled.story';
import {Error} from './Error.story';
import {Events} from './Events.story';
import {Hiddenelements} from './Hiddenelements.story';
import {Size} from './Size.story';

const basic = {
  rendered: <Basic />,
  source: `<DateField
  label="Date of birth"
  description="Enter your birthday"
/>`,
};

const onchange = {
  rendered: <Onchange />,
  source: `<DateField
  label="Date of birth"
  description="Enter your birthday"
  onChange={(e) => {
    console.log(e.target.value);
  }}
/>`,
};

const disabled = {
  rendered: <Disabled />,
  source: `<DateField
  label="Date of birth"
  description="Enter your birthday"
  defaultValue="2011-09-01"
  disabled
/>`,
};

const error = {
  rendered: <Error />,
  source: `<DateField
  label="Date of birth"
  description="Enter your birthday"
  defaultValue="2099-02-31"
  invalid
  error="Invalid birthday"
/>`,
};

const events = {
  rendered: <Events />,
  source: `<DateField
  label="Date of birth"
  description="Enter your birthday"
  onFocus={(e) => {
    console.log('focus', e);
  }}
  onBlur={(e) => {
    console.log('blur', e);
  }}
  onKeyPress={(e) => {
    console.log('keypress', e);
  }}
  onKeyDown={(e) => {
    console.log('keydown', e);
  }}
  onKeyUp={(e) => {
    console.log('keyup', e);
  }}
/>`,
};

const hiddenelements = {
  rendered: <Hiddenelements />,
  source: `<DateField
  label="Date of birth"
  description="Enter your birthday"
  defaultValue="2011-09-01"
  hiddenElements={['description', 'label']}
/>`,
};

const size = {
  rendered: <Size />,
  source: `<DateField
  label="Date of birth (small)"
  description="Enter your birthday"
  size="small"
/>
<DateField
  label="Date of birth (medium)"
  description="Enter your birthday"
  size="medium"
/>
<DateField
  label="Date of birth (large)"
  description="Enter your birthday"
  size="large"
/>`,
};

export const DateFieldExamples = {
  basic,
  onchange,
  disabled,
  error,
  events,
  hiddenelements,
  size,
};
